

export default function JoinUs() {
    return(
        <>
        <div class="JoinUs-IB"></div>
        <section class="JoinUs">
            <img src={require("../../JoinUs.jpg")} alt="Join Us" class="JoinUsImage"/>
            <div>
                <h1>Join Us</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies</p>
                <button class="Button T">Learn More</button>
            </div>
            <button class="Button D">Learn More</button>
        </section>
        </>
    )
}